import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@ngneat/reactive-forms';
import { debounceTime, startWith } from 'rxjs/operators';
import { Project } from 'src/app/classes/project.class';
import { Settlement } from 'src/app/classes/settlement.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { ProjectService } from 'src/app/services/project.service';
import { SettlementsService } from 'src/app/services/settlements.service';

@Component({
    selector: 'app-edit-settlement-project-dialog',
    templateUrl: './edit-settlement-project-dialog.component.html',
    styleUrls: ['./edit-settlement-project-dialog.component.scss'],
    standalone: false,
})
export class EditSettlementProjectDialogComponent extends CodaltComponent implements OnInit {
    projects: Project[] = [];

    fcProjectSearch = new FormControl<string>();

    searching = false;

    constructor(
        public dialogRef: MatDialogRef<EditSettlementProjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            settlements: Settlement[];
            currentProjectId: string;
        },
        private settlementService: SettlementsService,
        private projectService: ProjectService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.fcProjectSearch.valueChanges.pipe(debounceTime(200), startWith('')).subscribe(search => {
                this.subscriptions.add(
                    this.projectService.searchProjects(search).subscribe(projectResponse => {
                        this.projects = projectResponse.data?.filter(p => !!p.parent_id);
                    })
                );
            })
        );
    }

    selectProject(project: Project) {
        this.subscriptions.add(
            this.settlementService
                .changeProject(this.data.settlements, project.afas_project_id)
                .subscribe(settlements => {
                    this.dialogRef.close(settlements.data);
                })
        );
    }
}
